import { IHttpResponse, IHttpService, ILocationService, IWindowService, ITimeoutService } from "angular";
import { ErrorResponse } from "app/shared/model/response.model";
import { CookieService } from 'ngx-cookie-service';
import { LogBookRootScopeService } from "../shared/model/app.model";

angular.module('logbook')
	.directive('loginFields', ['$http', '$rootScope', '$location', '$window', '$timeout', 'cookieService',
		function(
			$http: IHttpService,
			$rootScope: LogBookRootScopeService,
			$location: ILocationService,
			$window: IWindowService,
			$timeout: ITimeoutService,
			cookieService: CookieService) {
		return {
			restrict: 'E',

			scope: {
				linkAccount: '='
			},

			template: require('./login-fields.html'),

			link: (scope, elem, attrs) => {
				$rootScope.cssLoaded = false;
				$rootScope.attemptedAutoLogin = false;
				scope.credentials = {};
				scope.params = {};
				scope.showPassword = false;
				scope.emailLoginOnly = cookieService.get('email-login-only') === 'true';
				scope.showSignup = !(cookieService.get('hide-signup') === 'true' || $location.search()['signup'] === 'false');
				
				if (scope.linkAccount)
					scope.credentials['link-account'] = 'Y';
				
				scope.login = (isAutoLogin: boolean = false) => {
					scope.error = false;
					delete scope.errorText;
					
					if( !scope.showPassword )
					{
						scope.checkEmail(scope.credentials.username, true);
						return;
					}
					

					$http.post('login', $.param(scope.credentials), {
						headers: {
							'content-type': 'application/x-www-form-urlencoded'
						}
					})
					.then(
						() => {
							$rootScope.authenticate(() => {
								if ($rootScope.authenticated) {
									
									scope.error = false;
								}
								else {
									$location.path('/login');
									scope.error = !isAutoLogin && true;
								}
							}, $location.search()['successUrl']);
						},
						(response: IHttpResponse<ErrorResponse>) => {
							let redir = response.headers('Location');

							if (redir) {
								$rootScope.cachePassword = scope.credentials.password;
								$location.path(redir);
							}
							else
								$location.path('/login');
							
							scope.error = !isAutoLogin && true;
							$rootScope.authenticated = false;
						}
					);
				};
				
				scope.doPasswordReset = () => {
					delete scope.resetPasswordError;

					let data = { email: scope.credentials.username },
						config = { noErrorPopup: true };

					$http.post('api/passwordReset', data, config).then(
						() => scope.sentPasswordEmail = true,
						error => scope.resetPasswordError = error
					);
				}
				
				scope.clearEmail = () => {
					delete scope.credentials.username;
					delete scope.showPassword;
					scope.error = false;
				};

				scope.simpleValidateEmail = (email: string) => {
					return /\S+@\S+\.\S+/.test(email);
				}

				scope.selectById = (id: string) => {
					$timeout(() => {
						(document.getElementById(id) as HTMLInputElement)?.select();
					})
				}
				scope.checkEmail = async (email: string, isUserEntered: boolean ) => {
					const result = await $http.get<any>(`/loginCheck?email=${email}`);
					if( scope.linkAccount === true && result.data.exclusive === true )
					{
						scope.errorText = "Cannot link to that account because it uses an exclusive login provider.";
						scope.error = true;
					}
					else if ( scope.linkAccount === true && result.data.redirUrl )
					{
						scope.errorText = "Linking to that account is not currently supported because it uses an external identity provider.";
						scope.error = true;
					}
					else if( result.data.redirUrl )
					{
						if( isUserEntered )
						{
							let domain = email.split('@').pop();
							if( domain )
								cookieService.set('LogBook-Login-Domain', domain, 3650);
							$window.location.href=result.data.redirUrl;
						}
						else
						{
							scope.loginProvider = result.data;
						}
					}
					else if( isUserEntered )
					{
						scope.showPassword = true;
						$timeout(() => {
							scope.selectById('password');

							// Attempt to login if password has been autofilled
							if (scope.credentials.password && !$rootScope.attemptedAutoLogin) {
								scope.login(true);
							}
							$rootScope.attemptedAutoLogin = true;
						});
					}
				};
				
				let loginDomain = cookieService.get('LogBook-Login-Domain');
				if( loginDomain )
				   scope.checkEmail('@'+loginDomain, false).then(() => scope.ready = true);
				else
					scope.ready = true;
					
				scope.clearLoginDomain = () => {
					cookieService.delete('LogBook-Login-Domain');
					delete scope.loginProvider;
				}
				scope.selectById('username');
				if( $location.search()['email'] )
				{
					scope.credentials.username = $location.search()['email'];
					scope.login();
				}

			}
		}
	}]);
